export default __webpack_public_path__ + "static/javelo_a1_cloud_testimonial_preview-6f0d77872fa6385014cf627c09cfafa7.webp";